import { beaufort } from "@/lib/meta";

export const de = (v, d = 1) => (v == null ? "–" : v.toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d }));

export const LIGHT = { green: "#3F5E45", yellow: "#C9962B", red: "#C65842", grey: "#8A8A8A" };

export const uvLevel = (uv) => {
  if (uv == null) return { label: "–", tone: "grey" };
  if (uv < 3) return { label: "niedrig", tone: "green", tip: "Kein Schutz nötig." };
  if (uv < 6) return { label: "mäßig", tone: "yellow", tip: "Mittags Sonnencreme und Kappe – der Wind täuscht." };
  if (uv < 8) return { label: "hoch", tone: "red", tip: "Schutz nötig, mittags Schatten im Strandkorb suchen." };
  return { label: uv < 11 ? "sehr hoch" : "extrem", tone: "red", tip: "Mittags Sonne meiden, LSF 50." };
};

export const aqiLevel = (v) => {
  if (v == null) return { label: "–", tone: "grey" };
  if (v <= 20) return { label: "sehr gut", tone: "green" };
  if (v <= 40) return { label: "gut", tone: "green" };
  if (v <= 60) return { label: "mäßig", tone: "yellow" };
  if (v <= 80) return { label: "schlecht", tone: "red" };
  return { label: "sehr schlecht", tone: "red" };
};

export const POLLEN = [
  { key: "alder_pollen", label: "Erle", weed: false },
  { key: "birch_pollen", label: "Birke", weed: false },
  { key: "grass_pollen", label: "Gräser", weed: false },
  { key: "mugwort_pollen", label: "Beifuß", weed: true },
  { key: "ragweed_pollen", label: "Ambrosia", weed: true },
];

export const pollenLevel = (v, weed) => {
  const [lo, hi] = weed ? [5, 20] : [10, 50];
  if (v == null) return { label: "–", tone: "grey", step: 0 };
  if (v < 1) return { label: "keine", tone: "grey", step: 0 };
  if (v < lo) return { label: "gering", tone: "green", step: 1 };
  if (v < hi) return { label: "mäßig", tone: "yellow", step: 2 };
  return { label: "stark", tone: "red", step: 3 };
};

export const activityLights = (t) => {
  const bft = beaufort(t.current?.wind_speed_10m ?? 0);
  const temp = t.current?.temperature_2m ?? 0;
  const rain = t.daily?.precipitation_probability_max?.[0] ?? 0;
  const bike = bft <= 3 ? ["green", "Entspannt rollen"] : bft <= 5 ? ["yellow", "Spürbarer Gegenwind"] : ["red", "Sehr anstrengend"];
  if (rain >= 60 && bike[0] === "green") bike.splice(0, 2, "yellow", "Regenjacke einpacken");
  const kite = bft < 3 ? ["red", "Zu wenig Wind"] : bft === 3 ? ["yellow", "Leichter Wind – großer Schirm"]
    : bft <= 6 ? ["green", "Gute Bedingungen"] : bft === 7 ? ["yellow", "Nur für Erfahrene"] : ["red", "Zu stürmisch"];
  const beach = temp >= 18 && bft <= 4 && rain < 40 ? ["green", "Ab in den Strandkorb"]
    : temp >= 13 && bft <= 5 && rain < 60 ? ["yellow", "Mit Jacke und Windschutz"] : ["red", "Lieber Spaziergang statt Liegen"];
  return { bft, items: [
    { key: "bike", label: "Radfahren", tone: bike[0], note: bike[1] },
    { key: "kite", label: "Kiten & Segeln", tone: t.coastal ? kite[0] : "grey", note: t.coastal ? kite[1] : "Kein Küstenort" },
    { key: "beach", label: "Strandkorb-Wetter", tone: beach[0], note: beach[1] },
  ] };
};

export const addMinutes = (iso, m) => {
  const d = new Date(iso);
  d.setMinutes(d.getMinutes() + m);
  return d.toISOString();
};
